export interface GuideShot {
  /** Public path e.g. /help/invoices/01.svg — falls back to illustrated frame if missing */
  src?: string
  caption: { ar: string; en: string; fr?: string }
  /** Visual motif when no image file is available */
  motif?: 'list' | 'form' | 'search' | 'print' | 'approve' | 'dashboard' | 'payment' | 'settings'
  highlight?: { ar: string; en: string; fr?: string }
}

export interface GuideStep {
  title: { ar: string; en: string; fr?: string }
  body: { ar: string; en: string; fr?: string }
  shot?: GuideShot
}

export interface GuideSection {
  title: { ar: string; en: string; fr?: string }
  steps: GuideStep[]
}

export interface PageGuide {
  /** Exact path or prefix (ends with *) */
  match: string | string[]
  title: { ar: string; en: string; fr?: string }
  summary: { ar: string; en: string; fr?: string }
  emoji?: string
  accent?: string
  sections: GuideSection[]
  tips?: { ar: string; en: string; fr?: string }[]
  /** Ordered gallery images shown at the top */
  gallery?: GuideShot[]
}

export type LangKey = 'ar' | 'en' | 'fr'

export function pickLang<T extends { ar: string; en: string; fr?: string }>(
  obj: T,
  language: string
): string {
  if (language === 'ar') return obj.ar
  if (language === 'fr' && obj.fr) return obj.fr
  return obj.en
}
